import axiosInstance from '../../axiosInstance';

export interface UnlinkWorkItemsPayload {
  linkedWorkItemUuid: string;
  sourceWorkItemUuid: string;
  targetWorkItemUuid: string;
}

export interface UnlinkWorkItemsResponse {
  response: string;
  message?: string;
  status?: boolean;
}

export const unlinkWorkItems = async (
  payload: UnlinkWorkItemsPayload
): Promise<UnlinkWorkItemsResponse> => {
  const { linkedWorkItemUuid, sourceWorkItemUuid, targetWorkItemUuid } = payload;
  const { data } = await axiosInstance.delete<UnlinkWorkItemsResponse>(
    `pmo/${linkedWorkItemUuid}/${sourceWorkItemUuid}/${targetWorkItemUuid}/unlink-work-item`
  );
  return data;
};
